const modalInstances = {};

export function getModalInstance(id) {
  const el = document.getElementById(id);
  if (!el) return null;

  if (!modalInstances[id]) {
    modalInstances[id] = new bootstrap.Modal(el);
  }
  return modalInstances[id];
}
